import type { ComponentTheme } from '../types/component-theme';

export default {
    slots: {
        root:
            'inline-flex min-w-22 flex-col rounded-xl border border-white/55 bg-[rgba(250,251,252,0.46)] px-2.5 ' +
            'py-1.5',
        label: 'text-[0.625rem] leading-none font-bold tracking-wide text-slate-400 uppercase',
        value: 'mt-1 text-xs leading-none font-bold text-slate-700'
    }
} satisfies ComponentTheme;
